import { SpecialistPage } from "../../../components/pages/specialist/SpecialistPage";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import {
  fetchAllSpecialists,
  fetchSpecialist,
} from "../../../services/fetch-data/specialistUtil";
import { SpecialistData } from "../../../hooks/react-query/useSpecialistList";
import { MyHead } from "../../../components/pages/MyHead";
import { Fragment } from "react";
import { NotFound } from "../../../components/pages/404/NotFound";

export async function getStaticProps(context: any) {
  const slug: string = context.params.slug;
  let specialist = undefined;
  if (!slug.includes("css"))
    specialist = await fetchSpecialist(
      `${context.locale}/${context.params.slug}`
    );

  return {
    props: {
      ...(await serverSideTranslations(context.locale, ["common"])),
      specialist: specialist || null,
    },
    revalidate: 60,
  };
}

/*
Prefetch all specialists on build
 */
export async function getStaticPaths() {
  const specialists = await fetchAllSpecialists();
  const paths: any[] = [];
  if (specialists) {
    Object.keys(specialists).map((slug) => {
      paths.push({ params: { slug: slug } });
    });
  }

  return {
    paths: paths,
    fallback: "blocking", //indicates the type of fallback
  };
}

function SpecialistEntry(params: {
  specialist: SpecialistData | null;
  authorSlug: string | null;
}) {
  const { specialist } = params;

  return (
    <Fragment>
      {specialist && (
        <Fragment>
          <MyHead
            title={specialist.name}
            description={`${specialist.name} - ${specialist.description}`}
            image={specialist.image}
            url={`/specialists/${specialist.urlSlug}`}
            SEODescription={specialist.SEODescription}
            SEOKeyword={specialist.SEOKeyword}
            SEOTitle={specialist.SEOTitle}
          />
          <SpecialistPage specialist={specialist} />
        </Fragment>
      )}
      {!specialist && <NotFound />}
    </Fragment>
  );
}

export default SpecialistEntry;
